// @flow

import React, { Component } from 'react'
import urlPaser from 'url'
import { containerIds } from 'redux/modules/ui'

export type NotificationSettingUseCaseType = {
  initialize: Function,
  changeEventSettingCheckState: Function,
  updateSetting: Function,
}

type Props = {
  config: {
    URL: string,
  },
  eventSetting: {},
  restClient: {},
  actions: {
    fetchEventSetting: Function,
    updateEventSetting: Function,
    setEventSetting: Function,
  },
}

export default (WrappedComponent: any) =>
  class NotificationSettingUseCase extends Component<Props> {
    // 初期処理
    initialize = () => {
      const { actions, restClient } = this.props
      actions.fetchEventSetting({ restClient })
    }

    // 設定の更新
    updateSetting = () => {
      const { config, actions, restClient, eventSetting } = this.props

      const urlObject = urlPaser.parse(config.URL)
      let doneUrl
      if (!!urlObject.search) {
        const params = new URLSearchParams(urlObject.search)
        doneUrl = decodeURIComponent(params.get('done'))
      }
      actions.fetchEventSetting({ restClient: this.props.restClient })

      actions.updateEventSetting({
        restClient,
        eventSetting,
        message: i18n.t('page.setting.updated'),
        doneUrl,
      })
    }

    // 設定のUI変更
    changeEventSettingCheckState = (e: Event) => {
      const { actions } = this.props
      const state = {}
      state[e.target.name] = e.target.checked
      actions.setEventSetting(state)
    }

    render() {
      return (
        <WrappedComponent {...this.props} notificationSettingUseCase={this} />
      )
    }
  }
